
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';

// Component
import BasePage from '@/pages/BasePage.vue';

// CMS
import { Tutorial, Step } from '@/apis/cms';

import { Route, RawLocation } from 'vue-router';

// Consts
import { HttpStatusCode } from '@/common/consts';
import { RouteConsts } from '@/routes/route';

import * as cmsApi from '@/apis/cms/api';
import { DEFAULT_CMS_CLIENT_CONFIG } from '@/plugins/api/cms';

// コードブロックのシンタックスハイライト
import hljs from 'highlight.js';
import 'highlight.js/styles/obsidian.css';
// クリップボード
import Clipboard from 'clipboard';

@Component
export default class TutorialStepPage extends Mixins<BasePage>(BasePage) {
  private tutorial: Tutorial = {} as Tutorial;

  private steps: Array<Step> = [];

  private selectedStep: Step = {} as Step;

  private selectedStepID: number = -1;

  private codeIdx: number = 0;

  private clipBoard: Clipboard = {} as Clipboard;

  private async getTutorial(tutorial_id: string) {
    // CMS API呼び出し
    const httpClient = await this.$cmsClient();
    const tutorial = await httpClient.tutorial
      .getTutorialByContentId(tutorial_id)
      .then(res => {
        const { data } = res;
        return data;
      });

    return tutorial;
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: TutorialStepPage) => any) | void) => void
  ) {
    // TODO チュートリアル一覧(TutorialsPage)から飛んできた際には、
    // チュートリアル用コンテンツは再利用可能。
    // beforeRouteEnterで受け渡しを考えるとCMSの呼び出し回数を削減できる

    // チュートリアル用コンテンツのオブジェクトをCMSから取ってくる
    const httpClient = new cmsApi.TutorialApi({ ...DEFAULT_CMS_CLIENT_CONFIG });
    const {
      data,
      err
    }: {
      data?: Tutorial;
      err?: any;
    } = await httpClient
      .getTutorialByContentId(to.params.tutorial_id)
      .then(res => {
        return res;
      })
      .catch(err => {
        return { err: err };
      });

    // 該当チュートリアルが取得できない場合はNotFoundに案内
    if (err) {
      next({ name: RouteConsts.NotFoundPage, params: { '0': to.path } });
    }

    // API is succeed
    if (!err && data) {
      const step_id = Number(to.params.step_id);
      if (
        data.steps !== undefined &&
        step_id >= 1 &&
        step_id <= data.steps.length
      ) {
        next((vm: TutorialStepPage) => {
          vm.tutorial = data;
          vm.steps = data.steps as Array<Step>;
          vm.steps = vm.steps.map(elm => {
            // descriptionを加工して保持しておく
            elm.description = vm.replaceAllCodeBlock(elm.description);
            elm.description = vm.replaceAllTableBlock(elm.description);
            elm.description = vm.replaceAllImg(elm.description);
            elm.description = vm.replaceAllUnsafe(elm.description);
            return elm;
          });
          const step_id = Number(to.params.step_id);
          vm.selectedStepID = step_id;
          vm.selectedStep = vm.steps[vm.selectedStepID - 1];
          return;
        });
      } else {
        next({ name: RouteConsts.NotFoundPage, params: { '0': to.path } });
      }
    }
    // API is failed
    else if (
      err.response &&
      err.response.status == HttpStatusCode.BAD_REQUEST
    ) {
      next({ name: RouteConsts.NotFoundPage, params: { '0': to.path } });
    } else next();
  }

  async beforeRouteUpdate(to: Route, from: Route, next: any) {
    // オブジェクトを再利用する場合は
    // selectedStepIDだけ更新して表示を更新する
    const step_id = Number(to.params.step_id);
    if (step_id >= 1 && step_id <= this.steps.length) {
      this.selectedStepID = step_id;
      this.selectedStep = this.steps[this.selectedStepID - 1];
      next();
    } else {
      next({ name: RouteConsts.NotFoundPage, params: { '0': to.path } });
    }
  }

  private goToNextStep() {
    this.$router.push({
      name: RouteConsts.TutorialStepPage,
      params: {
        tutorial_id: this.tutorial.id,
        step_id: (this.selectedStepID + 1).toString()
      }
    });
  }
  private goToPrevStep() {
    this.$router.push({
      name: RouteConsts.TutorialStepPage,
      params: {
        tutorial_id: this.tutorial.id,
        step_id: (this.selectedStepID - 1).toString()
      }
    });
  }
  private goToTutorialStep(tutorialId: string, stepId: string) {
    this.$router.push({
      name: RouteConsts.TutorialStepPage,
      params: { tutorial_id: tutorialId, step_id: stepId }
    });
  }
  private goToTutorials(tutorialId: string) {
    if (tutorialId.length > 0) {
      this.$router.push({
        name: RouteConsts.TutorialsPage,
        hash: '#' + tutorialId
      });
    } else {
      this.$router.push({
        name: RouteConsts.TutorialsPage
      });
    }
  }

  async created() {}
  async mounted() {
    this.clipBoard = new Clipboard('.clipBtn');
    this.clipBoard.on('success', this.clipboadSuccessed);
    this.clipBoard.on('error', this.clipboadError);
  }
  private clipboadSuccessed() {
    //通知を表示した方が親切
  }
  private clipboadError() {
    //通知を表示した方が親切
  }

  private replaceAllCodeBlock(description: string) {
    const newDescription = description.replace(
      //左側からの最短マッチなので<pre><code><pre><code></code></pre>はマッチしてしまうことに注意
      //コードブロック内に<pre><code></code></pre>は存在しない想定で実装
      /<pre><code>[\s\S]*?<\/code><\/pre>/g,
      this.highlight
    );
    return newDescription;
  }
  private replaceAllTableBlock(description: string) {
    //平文内の<>は特殊文字として変更されているので、特殊文字のままマッチング
    //ただし、/に関しては特殊文字ではなく平文のまま表示される仕様変更があったため、両方でマッチ
    const newDescription = description.replace(
      /&lt;table&gt;[\s\S]*?&lt;(\/|&#x2F;)table&gt;/g,
      this.fixTableBlock
    );
    return newDescription;
  }
  private replaceAllImg(description: string) {
    const newDescription = description.replace(
      /<img src="[\s\S]*?"[^>]*?>/g,
      this.fixImg
    );
    return newDescription;
  }
  private replaceAllUnsafe(description: string) {
    const newDescription = description.replace(
      /<a [^>]*?href="unsafe:[^>]*?">/g,
      this.fixUnsafe
    );
    return newDescription;
  }

  private highlight(matched: string) {
    // <pre><code> </pre></code>を除いた部分を取る
    const inner = matched.slice(11).slice(0, -13);
    //一行目の言語指定"[lang]"を抜き出す。ない場合はlang=plainとして扱う
    const res = inner.match(/^\[(.*?)\]\n/);
    var lang = '';
    if (res) {
      if (hljs.listLanguages().includes(res[1])) {
        lang = res[1];
      } else {
        lang = 'plain';
      }
    } else {
      lang = 'plain';
    }
    var code = inner.replace(/^\[.*?\]\n/, '');

    //指定された言語が存在すればハイライト
    if (lang !== 'plain') {
      // &で記述された特殊記法(&gt;など)を正しい文字列に直す
      const doc = new DOMParser().parseFromString(code, 'text/html');
      if (doc.documentElement.textContent) {
        code = doc.documentElement.textContent;
      }
      code = hljs.highlight(lang, code).value;
    }
    const idx = this.codeIdx;
    this.codeIdx = this.codeIdx + 1;

    //コピーボタンの挿入 data-clipboad-targetにはコードタグのidを取得する必要がある
    const copyBtn = `<button class="clipBtn" data-clipboard-target="#code${idx}"><i class="v-icon notranslate mdi mdi-content-copy" aria-hidden="true"></i></button>`;
    //言語の表示
    const langTag = `<div class="langTag"><p>${lang}</p></div>`;
    //ブロックの形にして返す
    return `<div>${langTag}${copyBtn}<pre><code id="code${idx}">${code}</code></pre></div>`;
  }
  private fixTableBlock(matched: string) {
    var str = matched.replace('<br>', '');
    const doc = new DOMParser().parseFromString(str, 'text/html');
    if (doc.documentElement.textContent) {
      str = doc.documentElement.textContent;
    }
    return str;
  }
  private fixImg(matched: string) {
    const res = matched.match(/<img src="([\s\S]*?)"([^>]*?)>/);
    if (res) {
      const src = res[1];
      const attributes = res[2];
      //data-lightboxを指定して、クリック時に拡大表示を行う
      return `<a href="${src}" data-lightbox="group"><img src="${src}"${attributes}></a>`;
    }
    return matched;
  }
  private fixUnsafe(matched: string) {
    const res = matched.match(/<a ([^>]*?)href="unsafe:([^>]*?)">/);
    if (res) {
      const attributes = res[1];
      const src = res[2];
      return `<a ${attributes}href="${src}">`;
    }
    return matched;
  }
}
